import React, { Component } from "react";
import Select from "react-select";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import InputField from "../../framework/InputField/InputField";
import Checkbox from "material-ui/Checkbox";
import Dialog from "material-ui/Dialog";
import "./edit-client-profile.css";
import Clear from "material-ui/svg-icons/content/clear";
import groupBy from "lodash/groupBy";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";
import CustomSelect from "../../framework/CustomSelect/CustomSelect";
import { FullRow } from "../../framework/Grid";
import MaskedInput from "react-text-mask";
import moment from "moment";
// add business unit detail component
import BusinessUnitsDetail from "./BusinessUnitsDetail";
var validator = require("email-validator");

const suspendDialogStyle = {
  cancel: {
    height: "30px",
    background: "white",
    color: "black",
    border: "1px solid black",
    fontWeight: "bold",
    marginRight: "10px",
    padding: "0 10px",
    fontSize: "12px",
  },
  suspend: {
    height: "30px",
    background: "#DD0000",
    color: "white",
    border: "none",
    fontWeight: "bold",
    padding: "0 10px",
    fontSize: "12px",
  },
};
const styles = {
  iconStyle: {
    fill: "#000000",
    transform: "scale(0.9)",
    WebkitTransform: "scale(0.9)",
    MsTransform: "scale(0.9)",
    MozTransform: "scale(0.9)",
    marginRight: "13px",
    marginLeft: "-1px",
  },
  labelStyle: {
    fontSize: "16px",
    lineHeight: "15px",
    marginBottom: 0,
    paddingTop: "3px",
    fontWeight: "normal",
  },
};
class ClientProfile extends Component {
  constructor(props) {
    super(props);
    this.throttle = true;
    this.state = {
      showDowngradeConfirm: false,
      ifShowSuspend: false,
      ifHiddenTopEdit: true,
      ifShowBusinessDetail: false, // when administrator login in the value will be trued
      timezoneValue: "",
      stateValue: "",
      industryGroupObj: [{ label: "", options: [] }],
      status: "",
      campaignReportPreference: "",
      audienceResolutionGranularity: "Scale",
      industry: {
        id: "",
        name: "",
      },
      subscription: {
        id: "",
        name: "",
      },
      accountManagers: [
        {
          id: "",
          firstName: "",
          lastName: "",
        },
      ],
      requestParams: {
        name: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zipCode: "",
        phone: "",
        timezone: "",
        industryId: "",
        subscriptionTierId: "",
        accountManagerUserIds: [""],
        campaignReportPreference: "",
      },
    };
  }
  componentDidMount() {
    this.props.getClientProfile(this.props.match.params.id);
    // set localStorage for Index.jsx edit/client-team-member url
    localStorage.setItem("editClientId", this.props.match.params.id);
    this.props.getTimezone();
    this.props.getIndustryOptions();
    this.props.getTierOptions();
    if (
      /^(system administrator|account manager)/gi.test(
        JSON.parse(localStorage.getItem("session")).roleName,
      )
    ) {
      this.props.getAccountManage();
    }
    this.props.getStates();
    if (this.props.edit_client_profile.subscriptionTierId >= 3) {
      this.props.getConfigInsightsStandard(this.props.match.params.id);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.edit_client_profile.subscriptionTierId >= 3 &&
      nextProps.edit_client_profile.subscriptionTierId != 5 &&
      nextProps.insights_standard_config === ""
    ) {
      nextProps.getConfigInsightsStandard(nextProps.match.params.id);
    }
    if (nextProps.industryOptions.length > 0) {
      let industryGroup = groupBy(nextProps.industryOptions, "group");
      let obj = [];
      for (let x in industryGroup) {
        obj.push({
          label: x,
          options: industryGroup[x],
        });
      }
      this.setState({
        industryGroupObj: obj,
      });
    }

    if (nextProps.edit_client_profile.name) {
      const {
        name,
        address1,
        address2,
        city,
        state,
        status,
        zipCode,
        phone,
        timezone,
        industryId,
        subscriptionTierId,
        accountManagerUserIds,
        industry,
        accountNumber,
        subscription,
        accountManagers,
        contractNumber,
        campaignReportPreference,
        clientReportDetailSetting,
        audienceResolutionGranularity,
        email,
        salesForceId,
      } = nextProps.edit_client_profile;
      if (nextProps.allstates.length > 0) {
        let stateValue =
          nextProps.allstates.filter((item) => item.value === state).length !==
            0 &&
          nextProps.allstates.filter((item) => item.value === state)[0].label;
        this.setState({
          stateValue,
        });
      }
      if (timezone.length > 0) {
        let timezoneValue =
          nextProps.timezone.filter((item) => item.value === timezone)
            .length !== 0 &&
          nextProps.timezone.filter((item) => item.value === timezone)[0].label;
        this.setState({
          timezoneValue,
        });
      }
      this.setState({
        status, // status can ben suspend or active,
        industry: typeof industry !== "undefined" && industry,
        subscription: typeof subscription !== "undefined" && subscription,
        accountManagers:
          typeof accountManagers !== "undefined" && accountManagers,
        audienceResolutionGranularity: audienceResolutionGranularity,
        requestParams: {
          ...this.state.requestParams,
          name,
          address1,
          address2,
          city,
          state,
          status,
          zipCode,
          phone,
          timezone,
          industryId,
          accountNumber,
          subscriptionTierId,
          accountManagerUserIds,
          campaignReportPreference,
          email,
          contractNumber:
            typeof contractNumber === "undefined" ? "" : contractNumber,
          salesForceId: salesForceId,
          clientReportDetailSetting: clientReportDetailSetting,
        },
      });
    }
  }
  handleEdit() {
    // if (/^(account manager|system administrator|administrator|team member)/gi.test(this.props.roleName)) {
    //   if (!this.state.ifHiddenTopEdit) {
    //     this.props.getClientProfile(this.props.match.params.id);
    //   }
    //   this.setState({
    //     ifHiddenTopEdit: !this.state.ifHiddenTopEdit
    //   })
    // }
    if (
      /^(account manager|system administrator|administrator|team member)/gi.test(
        this.props.roleName,
      )
    ) {
      this.setState({
        ifShowBusinessDetail: true,
        ifHiddenTopEdit: false,
      });
    }
  }
  handleTimeZoneChange(value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        timezone: value.value,
      },
    });
  }
  handleIndustryChange(value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        industryId: value.value,
      },
    });
  }
  handleSubscriptionTierChange(value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        subscriptionTierId: value.value,
      },
    });
  }
  handleReassignTo(value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        accountManagerUserIds: [value],
      },
    });
  }
  handleUpdate() {
    if (
      this.props.edit_client_profile.subscriptionTierId >= 3 &&
      this.props.edit_client_profile.subscriptionTierId != 5 &&
      this.state.requestParams.subscriptionTierId === 2
    ) {
      const { requestParams } = this.state;
      requestParams.insightsStandardConfig["segmentationSystem"] = null;
      requestParams.insightsStandardConfig["appendSegmentation"] = null;
      requestParams.insightsStandardConfig["segmentationLicenseNumber"] = null;
      requestParams.insightsStandardConfig["licenseExpirationDate"] = null;
      this.setState({
        showDowngradeConfirm: true,
      });
    } else {
      console.log(this.state.requestParams);
      if (this.state.requestParams.subscriptionTierId === 5) {
        this.setState({
          requiredEmailText: "",
        });
        if (this.state.requestParams.email.trim().length === 0) {
          this.setState({
            requiredEmailText: "Please enter email address",
          });
          return;
        } else {
          if (!validator.validate(this.state.requestParams.email.trim())) {
            this.setState({
              requiredEmailText: "Invalid email address",
            });
            return;
          }
        }
      }
      const { requestParams } = this.state;
      if (requestParams.subscriptionTierId === 4) {
        requestParams.insightsStandardConfig["segmentationSystem"] = this.state
          .segmentationSystem
          ? this.state.segmentationSystem
          : "prizm_premier";
        requestParams.insightsStandardConfig["appendSegmentation"] = this.state
          .appendSegmentation
          ? this.state.appendSegmentation
          : false;
        if (this.state.appendSegmentation === true) {
          requestParams.insightsStandardConfig[
            "segmentationLicenseNumber"
          ] = this.state.licenseNum;
          requestParams.insightsStandardConfig["licenseExpirationDate"] =
            this.state.expYear + "-" + this.state.expMonth + "-01";
        } else {
          requestParams.insightsStandardConfig[
            "segmentationLicenseNumber"
          ] = null;
          requestParams.insightsStandardConfig["licenseExpirationDate"] = null;
        }
      }
      if (
        requestParams.accountManagerUserIds &&
        requestParams.accountManagerUserIds.length > 0 &&
        requestParams.accountManagerUserIds[0] === ""
      ) {
        requestParams.accountManagerUserIds = undefined;
      } else {
        const vals = map(requestParams.accountManagerUserIds[0], "value");
        requestParams.accountManagerUserIds = vals;
      }

      this.props.updateClientProfile(
        this.props.match.params.id,
        this.state.requestParams,
      );
    }
  }
  handleClose() {
    this.props.getClientProfile(this.props.match.params.id);
    this.setState({
      ifHiddenTopEdit: true,
    });
    this.props.rollbackProfileStatus();
  }
  handleAddress1(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        address1: value,
      },
    });
  }
  handleAddress2(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        address2: value,
      },
    });
  }
  handleCity(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        city: value,
      },
    });
  }
  handleState(value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        state: value.value,
      },
    });
  }
  handleZipCode(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        zipCode: value,
      },
    });
  }
  handlePhone(e) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        phone: e.target.value,
      },
    });
  }
  handleSuspendUser() {
    this.setState({
      ifShowSuspend: true,
    });
  }
  handleCancelSuspend() {
    this.setState({
      ifShowSuspend: false,
    });
  }
  suspendUser() {
    let clientId = this.props.match.params.id;
    let status;
    if (this.state.status === "Suspended") {
      status = "reactivate";
    } else if (this.state.status === "Active") {
      status = "suspend";
    }
    this.props.suspendAndReactivate(clientId, status);
  }
  handleTitle(e, value) {
    //e.preventDefault();
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        name: value,
      },
    });
  }
  handleAccountNumber(e, value) {
    e.preventDefault();
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        accountNumber: value,
      },
    });
  }
  handleCancel() {
    /*
    this.setState({
      ifShowBusinessDetail: false
    })*/
    window.location.reload();
  }
  handleTopLocationReportCheck(e, isChecked) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        clientReportDetailSetting: {
          topLocationChannelReport: isChecked ? 1 : 0,
        },
      },
    });
  }
  handleEmail(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        email: value,
      },
    });
  }
  handleChangeEmail(e, value) {
    this.setState({
      requestParams: {
        ...this.state.requestParams,
        email: value,
      },
    });
  }
  ifShowAssignTo() {
    const ds =
      /^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname) &&
      /^administrator/gi.test(this.props.roleName)
        ? this.props.teamMember_options
        : this.props.account_manager;

    if (/^(system administrator)/gi.test(this.props.roleName)) {
      return true && !isEmpty(ds);
    }
    if (
      /^account manager/gi.test(this.props.roleName) &&
      /^\/clients\/edit\/Business-Units\/detail/g.test(
        this.props.location.pathname,
      )
    ) {
      return true && !isEmpty(ds);
    }
    if (
      /^administrator/gi.test(this.props.roleName) &&
      (/^\/clients\/edit\/Business-Units\/detail/g.test(
        this.props.location.pathname,
      ) ||
        /^\/clients\/edit\/Client-Profile/g.test(this.props.location.pathname))
    ) {
      return true && !isEmpty(ds);
    }

    if (
      /^team member/gi.test(this.props.roleName) &&
      /^\/clients\/edit\/Business-Units\/detail/g.test(
        this.props.location.pathname,
      )
    ) {
      return false;
    }
  }
  saveDowngradeClient(e) {
    e.preventDefault();
    this.props.updateClientProfile(
      this.props.match.params.id,
      this.state.requestParams,
    );
    this.setState({ showDowngradeConfirm: false });
  }
  render() {
    return (
      <div className="edit-client-profile">
        {!this.state.ifShowBusinessDetail && (
          <div className="edit-client-box">
            {this.state.ifHiddenTopEdit && (
              <div className="edit-client-shadow"></div>
            )}
            <div className="profile-fn-wrapper">
              <InputField
                labelTitle={
                  /^(account manager|system administrator)/gi.test(
                    this.props.roleName,
                  )
                    ? "Client Name"
                    : "Business Unit Name"
                }
                onChange={(e, value) => {
                  this.handleTitle(e, value);
                }}
                ifHasBorder={this.state.ifHiddenTopEdit}
                initValue={this.state.requestParams.name}
                hintText={this.state.requestParams.name}
                ifRequireField={true}
                borderColor="#B1B0B0"
                labelStyle={{
                  float: "left",
                  fontSize: "16px",
                  fontWeight: "bolder",
                  width: "30%",
                  margin: 0,
                }}
                inputContainerId="firstName"
                style={{
                  lineHeight: "40px",
                  borderBottom: this.state.ifHiddenTopEdit
                    ? "1px solid #E8EBEF"
                    : "",
                  marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                }}
              />
            </div>
            <div
              className="profile-fn-wrapper clearfix"
              style={{
                lineHeight: "42px",
                borderBottom: this.state.ifHiddenTopEdit
                  ? "1px solid #E8EBEF"
                  : "none",
                marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px",
              }}
            >
              <span
                style={{
                  float: "left",
                  fontSize: "16px",
                  fontWeight: "bolder",
                  width: "30%",
                }}
              >
                Profile Creation Date
              </span>
              <strong
                style={{
                  float: "left",
                  paddingLeft: "10px",
                  fontWeight: "normal",
                }}
              >
                {this.props.edit_client_profile.createdTime &&
                  moment(this.props.edit_client_profile.createdTime).format(
                    "M/D/YYYY",
                  )}
              </strong>
            </div>
            <div
              className="profile-fn-wrapper clearfix"
              style={{
                lineHeight: "42px",
                borderBottom: this.state.ifHiddenTopEdit
                  ? "1px solid #E8EBEF"
                  : "none",
                marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px",
              }}
            >
              <span
                style={{
                  float: "left",
                  fontSize: "16px",
                  fontWeight: "bolder",
                  width: "30%",
                }}
              >
                Status
              </span>
              <strong
                style={{
                  float: "left",
                  paddingLeft: "10px",
                  fontWeight: "normal",
                }}
              >
                {this.state.requestParams.status}
              </strong>
            </div>
            <div className="profile-fn-wrapper">
              <InputField
                labelTitle={
                  /^(account manager|system administrator)/gi.test(
                    this.props.roleName,
                  )
                    ? "Client Address 1"
                    : "Business Unit Address 1"
                }
                onChange={(e, value) => this.handleAddress1(e, value)}
                ifHasBorder={this.state.ifHiddenTopEdit}
                initValue={this.state.requestParams.address1}
                hintText={this.state.requestParams.address1}
                borderColor="black"
                labelStyle={{
                  float: "left",
                  fontSize: "16px",
                  fontWeight: "bolder",
                  width: "30%",
                  margin: 0,
                }}
                inputContainerId="firstName"
                style={{
                  lineHeight: "40px",
                  borderBottom: this.state.ifHiddenTopEdit
                    ? "1px solid #E8EBEF"
                    : "",
                  marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                }}
              />
            </div>
            <div className="profile-fn-wrapper">
              <InputField
                labelTitle={
                  /^(account manager|system administrator)/gi.test(
                    this.props.roleName,
                  )
                    ? "Client Address 2"
                    : "Business Unit Address 2"
                }
                onChange={(e, value) => this.handleAddress2(e, value)}
                ifHasBorder={this.state.ifHiddenTopEdit}
                initValue={this.state.requestParams.address2}
                hintText={this.state.requestParams.address2}
                borderColor="black"
                labelStyle={{
                  float: "left",
                  fontSize: "16px",
                  fontWeight: "bolder",
                  width: "30%",
                  margin: 0,
                }}
                inputContainerId="firstName"
                style={{
                  lineHeight: "40px",
                  borderBottom: this.state.ifHiddenTopEdit
                    ? "1px solid #E8EBEF"
                    : "",
                  marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                }}
              />
            </div>
            <div className="profile-fn-wrapper">
              <InputField
                labelTitle="City"
                onChange={(e, value) => this.handleCity(e, value)}
                ifHasBorder={this.state.ifHiddenTopEdit}
                initValue={this.state.requestParams.city}
                hintText={this.state.requestParams.city}
                borderColor="black"
                labelStyle={{
                  float: "left",
                  fontSize: "16px",
                  fontWeight: "bolder",
                  width: "30%",
                  margin: 0,
                }}
                inputContainerId="firstName"
                style={{
                  lineHeight: "40px",
                  borderBottom: this.state.ifHiddenTopEdit
                    ? "1px solid #E8EBEF"
                    : "",
                  marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                }}
              />
            </div>
            <div
              className="role clearfix"
              style={{
                lineHeight: "42px",
                borderBottom: this.state.ifHiddenTopEdit
                  ? "1px solid #E8EBEF"
                  : "",
                marginBottom: !this.state.ifHiddenTopEdit ? "26px" : "0",
              }}
            >
              <p
                style={{
                  color: "black",
                  fontSize: "16px",
                  float: "left",
                  width: "30%",
                  margin: 0,
                  fontWeight: "bolder",
                }}
              >
                State
              </p>
              {this.state.ifHiddenTopEdit ? (
                <div className="pull-left pl-10" style={{ width: "68%" }}>
                  {this.state.stateValue}
                </div>
              ) : (
                <Select
                  className="client-profile-timezone edit-state"
                  value={this.state.requestParams.state}
                  clearable={false}
                  options={this.props.allstates}
                  onChange={(value) => this.handleState(value)}
                />
              )}
            </div>
            <div className="profile-fn-wrapper">
              <InputField
                labelTitle="Zip Code"
                onChange={(e, value) => this.handleZipCode(e, value)}
                ifHasBorder={this.state.ifHiddenTopEdit}
                initValue={this.state.requestParams.zipCode}
                hintText={this.state.requestParams.zipCode}
                borderColor="black"
                labelStyle={{
                  float: "left",
                  fontSize: "16px",
                  fontWeight: "bolder",
                  width: "30%",
                  margin: 0,
                }}
                inputContainerId="firstName"
                style={{
                  lineHeight: "40px",
                  borderBottom: this.state.ifHiddenTopEdit
                    ? "1px solid #E8EBEF"
                    : "",
                  marginBottom: !this.state.ifHiddenTopEdit ? "26px" : 0,
                }}
              />
            </div>
            <div
              className="role clearfix"
              style={{
                lineHeight: "42px",
                borderBottom: this.state.ifHiddenTopEdit
                  ? "1px solid #E8EBEF"
                  : "",
                marginBottom: !this.state.ifHiddenTopEdit ? "26px" : "0",
              }}
            >
              <p
                style={{
                  color: "black",
                  fontSize: "16px",
                  float: "left",
                  width: "30%",
                  margin: 0,
                  fontWeight: "bolder",
                }}
              >
                Time Zone<em style={{ color: "red" }}>*</em>
              </p>
              {this.state.ifHiddenTopEdit ? (
                <div className="pull-left pl-10" style={{ width: "68%" }}>
                  {this.state.timezoneValue}
                </div>
              ) : (
                <Select
                  className="client-profile-timezone edit-timezone"
                  value={this.state.requestParams.timezone}
                  clearable={false}
                  options={this.props.timezone}
                  onChange={(value) => this.handleTimeZoneChange(value)}
                />
              )}
            </div>
            <div
              className="profile-mobile-phone-number clearfix"
              style={{
                borderBottom: this.state.ifHiddenTopEdit
                  ? "1px solid #E8EBEF"
                  : "",
                marginBottom: this.state.ifHiddenTopEdit ? "0" : "30px",
              }}
            >
              <span
                style={{ marginTop: this.state.ifHiddenTopEdit ? "" : "10px" }}
              >
                Mobile Phone Number
              </span>
              <MaskedInput
                className="mp-mask"
                guide={false}
                value={this.state.requestParams.phone}
                style={{
                  border: this.state.ifHiddenTopEdit ? "" : "1px solid #E8EBEF",
                  height: this.state.ifHiddenTopEdit ? "" : "32px",
                }}
                mask={[
                  "(",
                  /[1-9]/,
                  /\d/,
                  /\d/,
                  ")",
                  " ",
                  /\d/,
                  /\d/,
                  /\d/,
                  "-",
                  /\d/,
                  /\d/,
                  /\d/,
                  /\d/,
                ]}
                onChange={(e) => this.handlePhone(e)}
              />
            </div>
            {/^\/clients\/edit\/Client-Profile/g.test(
              this.props.location.pathname,
            ) &&
              /^(administrator|team member)/gi.test(this.props.roleName) && (
                <div
                  className="role clearfix"
                  style={{
                    lineHeight: "42px",
                    borderBottom: this.state.ifHiddenTopEdit
                      ? "1px solid #E8EBEF"
                      : "",
                    marginBottom: !this.state.ifHiddenTopEdit ? "20px" : "0",
                  }}
                >
                  <p
                    style={{
                      color: "black",
                      fontSize: "16px",
                      float: "left",
                      width: "30%",
                      margin: 0,
                      fontWeight: "bolder",
                    }}
                  >
                    Subscription Tier<em style={{ color: "red" }}>*</em>
                  </p>
                  {this.state.ifHiddenTopEdit ? (
                    <div className="pull-left pl-10" style={{ width: "68%" }}>
                      {this.state.subscription.name}
                    </div>
                  ) : (
                    /*<Select
                        className="client-profile-stimezone edit-subscription"
                        value={this.state.requestParams.subscriptionTierId}
                        clearable={false}
                        options={this.props.tier_options}
                        onChange={(value) => this.handleSubscriptionTierChange(value)}
                      />*/
                    <RadioButtonGroup
                      name="clientTier"
                      valueSelected={
                        this.state.requestParams.subscriptionTierId
                      }
                      onChange={(e, value) =>
                        this.handleSubscriptionTierChange(value)
                      }
                    >
                      <RadioButton
                        value={2}
                        label="Basic"
                        iconStyle={{
                          fill: "black",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                      <RadioButton
                        value={3}
                        label="Standard"
                        iconStyle={{
                          fill: "black",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                      <RadioButton
                        value={4}
                        label="Professional1"
                        iconStyle={{
                          fill: "black",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                    </RadioButtonGroup>
                  )}
                </div>
              )}
            <div className="profile-fn-wrapper">
              <InputField
                key="account-num-input"
                labelTitle="Account Number"
                onChange={(e, value) => this.handleAccountNumber(e, value)}
                ifHasBorder={this.state.ifHiddenTopEdit}
                initValue={this.state.requestParams.accountNumber}
                hintText={this.state.requestParams.accountNumber}
                ifRequireField={false}
                borderColor="black"
                labelStyle={{
                  float: "left",
                  fontSize: "16px",
                  fontWeight: "bolder",
                  width: "30%",
                  margin: 0,
                }}
                inputContainerId="firstName"
                style={{
                  lineHeight: "40px",
                  borderBottom: this.state.ifHiddenTopEdit
                    ? "1px solid #E8EBEF"
                    : "",
                  marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                }}
              />
            </div>
            {/*Contract Number*/}
            {/^(account manager|system administrator)/gi.test(
              this.props.roleName,
            ) && (
              <div className="profile-fn-wrapper">
                <InputField
                  labelTitle="Contract Number"
                  onChange={(e, value) => this.handleTitle(e, value)}
                  ifHasBorder={this.state.ifHiddenTopEdit}
                  initValue={this.state.requestParams.contractNumber}
                  hintText={this.state.requestParams.contractNumber}
                  ifRequireField={/^(account manager)/gi.test(
                    this.props.roleName,
                  )}
                  borderColor="black"
                  labelStyle={{
                    float: "left",
                    fontSize: "16px",
                    fontWeight: "bolder",
                    width: "30%",
                    margin: 0,
                  }}
                  inputContainerId="firstName"
                  style={{
                    lineHeight: "40px",
                    borderBottom: this.state.ifHiddenTopEdit
                      ? "1px solid #E8EBEF"
                      : "",
                    marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                  }}
                />
              </div>
            )}
            {
              <div className="profile-fn-wrapper">
                <InputField
                  maxLength={20}
                  labelTitle="Salesforce ID"
                  onChange={(e, value) => this.handleTitle(e, value)}
                  ifHasBorder={this.state.ifHiddenTopEdit}
                  initValue={this.state.requestParams.salesForceId}
                  hintText={this.state.requestParams.salesForceId}
                  ifRequireField={false}
                  borderColor="black"
                  labelStyle={{
                    float: "left",
                    fontSize: "16px",
                    fontWeight: "bolder",
                    width: "30%",
                    margin: 0,
                  }}
                  inputContainerId="firstName"
                  style={{
                    lineHeight: "40px",
                    borderBottom: this.state.ifHiddenTopEdit
                      ? "1px solid #E8EBEF"
                      : "",
                    marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                  }}
                />
              </div>
            }
            {/^\/clients\/edit\/Client-Profile/g.test(
              this.props.location.pathname,
            ) &&
              /^(system administrator|account manager)/gi.test(
                this.props.roleName,
              ) && (
                <div
                  className="role clearfix"
                  style={{
                    lineHeight: "42px",
                    borderBottom: this.state.ifHiddenTopEdit
                      ? "1px solid #E8EBEF"
                      : "",
                    marginBottom: !this.state.ifHiddenTopEdit ? "20px" : "0",
                  }}
                >
                  <p
                    style={{
                      color: "black",
                      fontSize: "16px",
                      float: "left",
                      width: "30%",
                      margin: 0,
                      fontWeight: "bolder",
                    }}
                  >
                    Subscription Tier<em style={{ color: "red" }}>*</em>
                  </p>
                  {this.state.ifHiddenTopEdit ? (
                    <div className="pull-left pl-10" style={{ width: "68%" }}>
                      {this.state.subscription.name}
                    </div>
                  ) : (
                    <Select
                      className="client-profile-stimezone edit-subscription"
                      value={this.state.requestParams.subscriptionTierId}
                      clearable={false}
                      options={this.props.tier_options}
                      onChange={(value) =>
                        this.handleSubscriptionTierChange(value)
                      }
                    />
                  )}
                </div>
              )}
            {/^(system administrator|account manager)/gi.test(
              this.props.roleName,
            ) &&
              this.state.requestParams.subscriptionTierId === 5 && (
                <div className="profile-fn-wrapper">
                  <InputField
                    labelTitle="Email"
                    maxLength={120}
                    handleOnBlur={(e, value) => this.handleEmail(e, value)}
                    onChange={(e, value) => this.handleChangeEmail(e, value)}
                    ifHasBorder={this.state.ifHiddenTopEdit}
                    initValue={
                      this.state.requestParams.email === null
                        ? ""
                        : this.state.requestParams.email
                    }
                    ifRequireField={true}
                    borderCorlor="black"
                    labelStyle={{
                      float: "left",
                      fontWeight: "bolder",
                      fontSize: "16px",
                      width: "30%",
                      margin: 0,
                    }}
                    inputContainerId="firstName"
                    style={{
                      lineHeight: "40px",
                      borderBottom: this.state.ifHiddenTopEdit
                        ? "1px solid #E8EBEF"
                        : "",
                      marginBottom: !this.state.ifHiddenTopEdit ? "30px" : 0,
                    }}
                  />
                  {this.state.requiredEmailText && (
                    <p className="create-account-field-error clearfix">
                      <Error style={{ float: "left" }} color="red" />
                      <span>{this.state.requiredEmailText}</span>
                    </p>
                  )}
                </div>
              )}
            {/*for create client profile*/}
            {/^(system administrator|account manager)/gi.test(
              this.props.roleName,
            ) &&
              this.state.requestParams.subscriptionTierId >= 3 &&
              this.state.requestParams.subscriptionTierId < 5 && (
                <div
                  className="role clearfix"
                  style={{
                    lineHeight: "42px",
                    borderBottom: this.state.ifHiddenTopEdit
                      ? "1px solid #E8EBEF"
                      : "",
                    marginBottom: !this.state.ifHiddenTopEdit ? "20px" : "0",
                  }}
                >
                  <p
                    style={{
                      color: "black",
                      fontSize: "16px",
                      float: "left",
                      width: "31.3%",
                      margin: 0,
                      fontWeight: "bolder",
                    }}
                  >
                    Account Download Options<em style={{ color: "red" }}>*</em>
                  </p>
                  <div style={{ float: "left" }}>
                    {this.state.audienceResolutionGranularity}
                  </div>
                </div>
              )}
            {/^(system administrator|account manager)/gi.test(
              this.props.roleName,
            ) &&
              ((this.state.requestParams.subscriptionTierId >= 3 &&
                this.state.requestParams.subscriptionTierId != 5) ||
                this.state.requestParams.subscriptionTierId === 1) && (
                <div
                  className="role clearfix"
                  style={{
                    lineHeight: "42px",
                    borderBottom: this.state.ifHiddenTopEdit
                      ? "1px solid #E8EBEF"
                      : "",
                    marginBottom: !this.state.ifHiddenTopEdit ? "20px" : "0",
                  }}
                >
                  <p
                    style={{
                      color: "black",
                      fontSize: "16px",
                      float: "left",
                      width: "31.3%",
                      margin: 0,
                      fontWeight: "bolder",
                    }}
                  >
                    Data Source<em style={{ color: "red" }}>*</em>
                  </p>
                  <div style={{ float: "left" }}>
                    <section>
                      <strong>Consumer</strong> -{" "}
                      <span>
                        {this.props.insights_standard_config !== "" &&
                          this.props.insights_standard_config
                            .consumerDataSource}
                      </span>
                    </section>
                    <section>
                      <strong>Business</strong> -{" "}
                      <span>
                        {this.props.insights_standard_config !== "" &&
                          this.props.insights_standard_config
                            .businessDataSource}
                      </span>
                    </section>
                  </div>
                </div>
              )}

            {/^(system administrator|account manager)/gi.test(
              this.props.roleName,
            ) && (
              <div
                className="role clearfix"
                style={
                  this.state.ifHiddenTopEdit
                    ? {
                        lineHeight: "42px",
                        borderBottom: "1px solid #E8EBEF",
                        marginBottom: "0px",
                      }
                    : { lineHeight: "32px", marginBottom: "30px" }
                }
              >
                <p
                  style={{
                    color: "black",
                    fontSize: "16px",
                    float: "left",
                    width: "30%",
                    margin: 0,
                    fontWeight: "bolder",
                  }}
                >
                  Campaign Reporting <em style={{ color: "red" }}>*</em>
                </p>
                {this.state.ifHiddenTopEdit ? (
                  <div className="ml-10 pull-left">
                    {this.state.requestParams.campaignReportPreference &&
                      (this.state.requestParams.campaignReportPreference ===
                      "Detailed"
                        ? "Detailed Campaign Reporting"
                        : "Aggregate")}
                  </div>
                ) : (
                  <div
                    style={{ float: "left", minWidth: "400px", width: "68%" }}
                  >
                    <RadioButtonGroup
                      name="reportType"
                      valueSelected={
                        this.state.requestParams.campaignReportPreference
                      }
                      onChange={(e, value) => {
                        e.preventDefault();
                      }}
                    >
                      <RadioButton
                        value="Aggregated"
                        label="Aggregate"
                        iconStyle={{
                          fill: "black",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                      <RadioButton
                        value="Detailed"
                        label="Detailed Campaign Reporting"
                        iconStyle={{
                          fill: "black",
                          width: "20px",
                          height: "20px",
                        }}
                      />
                    </RadioButtonGroup>
                    <div
                      className="pt-10"
                      style={{
                        borderTop: "solid 1px #000000",
                        display:
                          this.state.requestParams.campaignReportPreference ===
                          "Detailed"
                            ? "block"
                            : "none",
                      }}
                    >
                      <Checkbox
                        label="Display Top Locations on Channel Reports"
                        checked={
                          this.state.requestParams.clientReportDetailSetting &&
                          this.state.requestParams.clientReportDetailSetting
                            .topLocationChannelReport
                        }
                        onCheck={(e, isInputChecked) =>
                          this.handleTopLocationReportCheck(e, isInputChecked)
                        }
                        iconStyle={styles.iconStyle}
                        labelStyle={styles.labelStyle}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
            {/*
              ((this.state.requestParams.subscriptionTierId === 3) &&
              /^(system administrator|account manager|administrator)/gi.test(this.props.roleName)) && (
                <div style={{display: this.state.ifHiddenTopEdit ? 'none' : 'block', paddingLeft: '30%', paddingBottom: '29px'}}>
                  <section style={{marginBottom: '29px'}}>
                    <span>Maximum Monthly Consumer Records <input disabled={/^(administrator|team member)/gi.test(this.props.roleName)} onBlur={(e) => this.handleConsumerRecords(e)} ref="consumer" type="text" style={{textAlign: 'center', border: /^(administrator|team member)/gi.test(this.props.roleName) ? 'none' : '1px solid #E8EBEF', width: '49px', height: '30px', marginLeft: /^(administrator|team member)/gi.test(this.props.roleName) ? '0' : '15px'}}/></span>
                  </section>
                  <section>
                    <span>Maximum Monthly Business Records <input disabled={/^(administrator|team member)/gi.test(this.props.roleName)} onBlur={(e) => this.handleBusinessRecords(e)} ref="business" type="text" style={{textAlign: 'center', border: /^(administrator|team member)/gi.test(this.props.roleName) ? 'none' : '1px solid #E8EBEF', width: '49px', height: '30px', marginLeft: /^(administrator|team member)/gi.test(this.props.roleName) ? '8px' : '22px'}}/></span>
                  </section>
                </div>
              )*/}
            <div
              className="role clearfix"
              style={{
                lineHeight: "42px",
                borderBottom: this.state.ifHiddenTopEdit
                  ? "1px solid #E8EBEF"
                  : "",
                marginBottom: !this.state.ifHiddenTopEdit ? "20px" : "0",
              }}
            >
              <p
                style={{
                  color: "black",
                  fontSize: "16px",
                  float: "left",
                  width: "30%",
                  margin: 0,
                  fontWeight: "bolder",
                }}
              >
                Industry Type<em style={{ color: "red" }}>*</em>
              </p>
              {this.state.ifHiddenTopEdit ? (
                <div className="pull-left pl-10" style={{ width: "68%" }}>
                  {this.state.industry.name}
                </div>
              ) : (
                <CustomSelect
                  placeholder="Select Industry Type"
                  options={this.state.industryGroupObj}
                  rootStyles={{
                    float: "left",
                    width: "68%",
                    border: "1px solid #E8EBEF",
                  }}
                  onChange={(value) => this.handleIndustryChange(value)}
                  initValue={this.state.requestParams.industryId}
                />
              )}
            </div>
            {this.ifShowAssignTo() && (
              <div
                className="role clearfix"
                style={{
                  lineHeight: "42px",
                  borderBottom: this.state.ifHiddenTopEdit
                    ? "1px solid #E8EBEF"
                    : "",
                  marginBottom: !this.state.ifHiddenTopEdit ? "20px" : "0",
                }}
              >
                <p
                  style={{
                    color: "black",
                    fontSize: "16px",
                    float: "left",
                    width: "30%",
                    margin: 0,
                    fontWeight: "bolder",
                  }}
                >
                  {/^(administrator|team member)/gi.test(this.props.roleName)
                    ? "Assign Business Unit to"
                    : "Assign Client to"}
                  {/^system administrator/gi.test(this.props.roleName) && (
                    <em style={{ color: "red" }}>*</em>
                  )}
                </p>
                {this.state.ifHiddenTopEdit ? (
                  <div className="pull-left pl-10" style={{ width: "68%" }}>
                    {map(this.state.accountManagers, (data) => {
                      return data.firstName + " " + data.lastName;
                    }).join(", ")}
                  </div>
                ) : (
                  <Select
                    className="client-profile-timezone"
                    value={this.state.requestParams.accountManagerUserIds}
                    clearable={false}
                    options={this.props.account_manager}
                    multi
                    simpleValue
                    onChange={(value) => this.handleReassignTo(value)}
                  />
                )}
              </div>
            )}
            {this.state.ifHiddenTopEdit ? (
              <div className="btns">
                <button className="edit" onClick={() => this.handleEdit()}>
                  EDIT
                </button>

                <button
                  className="suspend"
                  onClick={() => this.handleSuspendUser()}
                >
                  {this.state.status === "Active" && "SUSPEND"}
                  {this.state.status === "Suspended" && "REACTIVATE"}{" "}
                  {/^(account manager|system administrator)/gi.test(
                    this.props.roleName,
                  )
                    ? "CLIENT"
                    : "BUSINESS UNIT"}
                </button>
              </div>
            ) : (
              <div className="btns">
                <button className="cancel" onClick={() => this.handleEdit()}>
                  CANCEL
                </button>
                <button
                  className="save"
                  disabled={!this.state.accountManagerUserIds}
                  onClick={() => this.handleUpdate()}
                >
                  SAVE
                </button>
              </div>
            )}
          </div>
        )}

        {/*if administrator or team member login in show below component*/}
        {this.state.ifShowBusinessDetail && (
          <BusinessUnitsDetail
            {...this.props}
            editMode={true}
            handleCancel={() => this.handleCancel()}
            match={{
              params: {
                businessUnitId: this.props.match.params.id,
              },
            }}
          />
        )}

        {/*success popover*/}
        <Dialog
          modal={true}
          contentStyle={{ width: "40%" }}
          open={this.props.ifEditClientProfileSuccess}
          bodyStyle={{ padding: "20px" }}
        >
          <div className="clearfix" style={{ position: "relative" }}>
            <Clear
              style={{
                position: "absolute",
                right: "0em",
                cursor: "pointer",
                top: "0em",
              }}
              onClick={() => this.handleClose()}
            />
            <h2
              style={{
                fontSize: "16px",
                fontWeight: "bolder",
                color: "black",
                marginTop: "0",
              }}
            >
              UPDATE CLIENT PROFILE
            </h2>
            {this.props.ifEditClientProfileSuccess && (
              <p
                style={{
                  textAlign: "center",
                  color: "black",
                  marginTop: "1.2em",
                }}
              >
                The profile was updated successfully.
              </p>
            )}
            <div className="form-btns clearfix" style={{ marginTop: "19px" }}>
              <a
                className="btn btn-link pull-right "
                id="userStatusA"
                style={{
                  marginLeft: "-1.3em",
                  border: "1px solid black",
                  fontWeight: "bolder",
                  padding: "7px 17px",
                  borderRadius: "0",
                  marginRight: "0.8em",
                }}
                onClick={(e) => this.handleClose()}
              >
                Close
              </a>
            </div>
          </div>
        </Dialog>
        {/*suspend and reactivate user*/}
        <Dialog modal={false} open={this.state.ifShowSuspend}>
          <p style={{ textAlign: "center", color: "black" }}>
            Are you sure you would like to{" "}
            {this.state.status === "Active" ? "suspend" : "reactivate"} this{" "}
            {/^(administrator|team member)/gi.test(this.props.roleName)
              ? "business unit"
              : "client"}
            ?
          </p>
          <div className="btns" style={{ textAlign: "center" }}>
            <button
              style={suspendDialogStyle.cancel}
              onClick={() => this.handleCancelSuspend()}
            >
              CANCEL
            </button>
            <button
              style={suspendDialogStyle.suspend}
              onClick={() => this.suspendUser()}
            >
              {this.state.status === "Active" ? "SUSPEND" : "REACTIVATE"}{" "}
              {/^(administrator|team member)/gi.test(this.props.roleName)
                ? "BUSINESS UNIT"
                : "CLIENT"}
            </button>
          </div>
        </Dialog>
        <Dialog
          open={this.state.showDowngradeConfirm}
          contentStyle={{ width: "435px", padding: "20px" }}
        >
          <p style={{ fontWeight: "bold", color: "#000" }}>
            Changing the subscription tier to Basic will stop file exports,
            limit some reporting views, and limit the number of segments that
            can be saved.
          </p>
          <FullRow className="text-center no-padding-bottom no-margin-bottom">
            <a
              className="btn btn-default btn-aa-info"
              onClick={(e) => {
                e.preventDefault();
                this.setState({ showDowngradeConfirm: false });
              }}
            >
              Cancel
            </a>
            <a
              className="btn btn-default btn-aa-warning ml-20"
              onClick={this.saveDowngradeClient.bind(this)}
            >
              Continue
            </a>
          </FullRow>
        </Dialog>
      </div>
    );
  }
}

export default ClientProfile;



// WEBPACK FOOTER //
// ./src/components/Clients/EditClientProfile/ClientProfile.jsx